import { IS_IFRAME_MODE } from 'config/envVariable';
import { IS_OFFLINE, IS_END, IS_SUSPEND } from 'config/promoOnlineStatus';
import { loginTypes } from 'config/loginTypes';
import { gameRunningStatuses } from 'config/gameRunningStatuses';
import { reducePointModes } from 'config/enterpriseReducePointMode';
import { hasUtcDTStartInLocal, hasUtcDTEndInLocal } from 'utils/dateTime';
import getPeriodPlayMatchedInfo from 'client/hooks/useInitPromo/getPeriodPlayMatchedInfo';
import { getQsOfParentUrl } from 'client/utils/queryString';

export default function getPromoState(state, qs) {
    const {
        settingPromo: { periodPlayMode, periodTime, timezone }
    } = state;
    const { test_code, test_expired, parentUrl = '', scenes, mode } = qs;
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmFromParentUrl(
        parentUrl
    );
    const { status: gameRunningStatus, isTestMode = false } = getGameRunningStatus(state, {
        hasTestQs: Boolean(test_code) && Boolean(test_expired),
        hasPreviewQs: mode === 'preview'
    });
    return {
        periodPlayMatchedInfo: getPeriodPlayMatchedInfo({
            periodPlayMode,
            periodTime,
            timezone
        }),
        isTestMode,
        enablePasscodeVerify: checkEnablePasscodeVerify(state),
        gameRunningStatus,
        reducePointMode: getReducePointMode(state),
        parentUrl,
        scenes,
        utmFromParent: {
            utm_source,
            utm_medium,
            utm_campaign,
            utm_term,
            utm_content
        }
    };
}

function getUtmFromParentUrl(parentUrl) {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getQsOfParentUrl(
        parentUrl
    );
    return { utm_source, utm_medium, utm_campaign, utm_term, utm_content };
}
function getGameRunningStatus(state, { hasTestQs, hasPreviewQs }) {
    const {
        promo: { status: promoStatus },
        settingPromo: { startDate, endDate },
        zines: { pageId } = {}
    } = state;

    if (IS_IFRAME_MODE && pageId !== undefined && hasPreviewQs) {
        return { status: gameRunningStatuses.NOT_PUBLISH };
    }
    if (promoStatus === IS_OFFLINE) {
        if (hasTestQs) {
            return { status: gameRunningStatuses.RUNNING, isTestMode: true };
        } else {
            return { status: gameRunningStatuses.NOT_PUBLISH };
        }
    } else if (promoStatus === IS_SUSPEND) {
        return { status: gameRunningStatuses.SUSPEND };
    } else if (promoStatus === IS_END || hasUtcDTEndInLocal(endDate)) {
        return { status: gameRunningStatuses.END };
    } else {
        if (!hasUtcDTStartInLocal(startDate)) {
            return { status: gameRunningStatuses.BEFORE };
        } else {
            return { status: gameRunningStatuses.RUNNING };
        }
    }
}
function getReducePointMode(state) {
    const {
        settingPromo: {
            loginMethod,
            enableKkpoint,
            kkpointAmount,
            transactionWithdraw,
            transactionWithdrawQuantity
        },
        settingPointSystems = {}
    } = state;

    // 企業(會員點數)
    if (loginMethod === loginTypes.ENTERPRISELOGIN) {
        if (Boolean(enableKkpoint) && kkpointAmount !== undefined) {
            return reducePointModes.KK_BOX;
        } else if (Boolean(transactionWithdraw) && transactionWithdrawQuantity !== undefined) {
            return reducePointModes.GENERAL;
        }
    }
    // FEVER(活動點數)
    if (
        loginMethod === loginTypes.FACEBOOKLOGIN ||
        loginMethod === loginTypes.LINELOGIN ||
        loginMethod === loginTypes.ENTERPRISELOGIN
    ) {
        const shouldReducePromoPointForJoinPromo =
            Boolean(settingPointSystems?.qualifyWithdrawUuid) &&
            transactionWithdrawQuantity !== undefined;

        if (shouldReducePromoPointForJoinPromo) {
            return reducePointModes.POINT_SYSTEMS;
        }
    }
    return '';
}
function checkEnablePasscodeVerify(state) {
    const {
        settingPromo: { enableQualificationPasscode }
    } = state;
    return Boolean(enableQualificationPasscode);
}
